import { render } from "./PrivacyView.vue?vue&type=template&id=2fb810e9"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__